import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { grey10, navy } from '@zocdoc/branding/colors';
import { FontFamily } from '../../../typography';

import Close from '../../../icons/Close';
import { Spinner } from '../../../Spinner';
import { ScanCardUploadConnector } from './Upload/ScanCardUploadConnector';
import { ScanCardInsurancePickerConnector } from './InsurancePicker/ScanCardInsurancePickerConnector';

import {
    SCAN_CARD_STATUS_INITIAL,
    SCAN_CARD_STATUS_LOADING,
    SCAN_CARD_STATUS_SUCCESS,
} from '../../data/scan-card/scanCardReducer';
import { MetricsClickable, Metrics } from '@zocdoc/frontend-metrics';

class BaseScanCardContainerView extends Component {
    render() {
        const { status } = this.props;

        const cardUploader = status === SCAN_CARD_STATUS_INITIAL ? <ScanCardUploadConnector /> : null;

        const insurancePicker =
            status === SCAN_CARD_STATUS_SUCCESS || status === SCAN_CARD_STATUS_LOADING ? (
                <ScanCardInsurancePickerConnector />
            ) : null;

        return (
            <Metrics component="InsurancePickerScanCard">
                <ScanCard>
                    <MetricsClickable
                        action="Insurance Picker Scan - Close Scan Card"
                        element="CloseButton"
                    >
                        <StyledClose onClick={this.props.closeDropDownAndClearCard} />
                    </MetricsClickable>
                    {this.maybeRenderLoader()}
                    {cardUploader}
                    {insurancePicker}
                </ScanCard>
            </Metrics>
        );
    }

    maybeRenderLoader() {
        if (this.props.status === SCAN_CARD_STATUS_LOADING) {
            return (
                <LoadingContainer data-test="loading-message">
                    <StyledSpinner
                        alt="Loading"
                        data-test="loading-spinner"
                        inline
                        size={32}
                    />
                    <LoadingText>
                        <FormattedMessage
                            defaultMessage="Scanning your card…"
                            id="Components.InsurancePicker.ScanCardLoaderMsg"
                        />
                    </LoadingText>
                </LoadingContainer>
            );
        }
    }
}

const ScanCard = styled.div`
    position: fixed;
    height: 100%;
    left: 0;
    top: 0;
    background-color: ${grey10};
    z-index: 5;
    box-sizing: border-box;
    width: 100%;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 50px;
`;

const StyledClose = styled(Close)`
    right: 18px;
    top: 14px;
    width: 16px;
    height: 16px;
    position: absolute;
    z-index: 2;
`;

const LoadingContainer = styled.div`
    background: rgba(255, 255, 255, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
`;

const StyledSpinner = styled(Spinner)`
    margin-top: 24px;
`;

const LoadingText = styled.div`
    font: 15px/18px ${FontFamily.SharpSansSemibold};
    color: ${navy};
    padding-top: 6px;
`;

export const ScanCardContainerView = injectIntl(BaseScanCardContainerView);
